import { Editor } from "@tiptap/core";
import { Metrics, Pair as MetricPair } from "../metrics";
import classNames from "classnames";
import { CheckStatus } from "../hooks/CheckStatus";

type StatusBarProps = {
    editor: Editor,
    metrics: Metrics|undefined|null
    status: CheckStatus
}


const StatusBar = ({ editor, status, metrics }: StatusBarProps) => {
    return (<div className="status-bar">
        <CharacterCount editor={editor} status={status} metrics={metrics} />
        { metrics && <MetricsComponent metrics={metrics} /> }
    </div>)
}

const CharacterCount = ({ editor, status, metrics }: StatusBarProps) => {

    const char = editor ? <div>
        <strong>Caràcters</strong>: {editor.storage.characterCount.characters()}/30.000
    </div> : <></>

    const dirtyMessage = 
        status === CheckStatus.Checking ?
            <span className="grey">⏳</span> :
        metrics && metrics.dirty ? <small>Les mètriques poden estar desactualitzades</small> : <></>

    return (<div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        {char}
        {dirtyMessage}
    </div>)
}

const MetricsComponent = ({ metrics } : { metrics: Metrics}) => {
    return (
        <div style={{display: "flex", flexFlow: "row wrap", justifyContent: "space-between"}}>
            <div style={{display: "flex", flexDirection: "column"}}>
                <Pair dirty={metrics.dirty} pair={{ 
                    name: 'Paraules', 
                    value: `${metrics.words.value}` 
                    }} />
                <Pair dirty={metrics.dirty} pair={metrics.paragraphs} />
            </div>
            <div style={{display: "flex", flexDirection: "column"}}>
                <Pair dirty={metrics.dirty}  pair={metrics.sentences} />
                <Pair dirty={metrics.dirty}  pair={metrics.syllabes} />
            </div>
            <div style={{display: "flex", flexDirection: "column"}}>
                <Pair dirty={metrics.dirty}  pair={metrics.read_time} />
                <Pair dirty={metrics.dirty}  pair={metrics.speak_time} />
            </div>
        </div>
    )
}

type PairProps = {
    dirty: boolean
    pair: MetricPair
}
const Pair = ({ pair, dirty } : PairProps) => {
    return <div><strong>{pair.name}</strong>: <span className={classNames({ dirty })}>{pair.value}</span></div>
}
export default StatusBar